import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { CardLayout } from '@modules/card/enums/card-layout.enum';
import { Screen } from '@modules/shared/services/window.service';

import { CardComponent } from '../../card/card/card.component';
import { MediaComponent } from '../../media/media.component';
import { Equal4SectionModel } from '../models/equal-4-section.model';
import { SectionDefaultsComponent } from '../section-defaults';

@Component({
  selector: 'mb-equal4-section',
  templateUrl: './equal4-section.component.html',
  styleUrls: ['./equal4-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CardComponent, MediaComponent],
})
export class Equal4SectionComponent extends SectionDefaultsComponent {
  public layouts = {
    [Screen.XXXS]: CardLayout.COLUMN,
    [Screen.XS]: CardLayout.ROW,
  };
  @Input() data!: Equal4SectionModel;
}
